module.exports = __webpack_public_path__ + "media/images/proof_links/marketyandex-9439a594b61221abfdaf91b5d5678fee.svg";